import React, { useState } from "react";

// @ts-ignore
import { createStyles, makeStyles } from "@material-ui/core/styles";

import Avatar from "@material-ui/core/Avatar";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
// import GridList from "@material-ui/core/GridList";
// import GridListTile from "@material-ui/core/GridListTile";
// import Icon from "@material-ui/core/Icon";

import "../../node_modules/leaflet/dist/leaflet.css";
// import "../../node_modules/react-leaflet-markercluster/dist/styles.css";
import "../../node_modules/react-leaflet-markercluster/dist/styles.min.css";

import L from "leaflet";
import {
  MapContainer,
  Marker,
  Popup,
  TileLayer /*, GeoJSON*/,
  // useLeaflet,
} from "react-leaflet";

import MarkerClusterGroup from "react-leaflet-markercluster";
import { NodeMapList } from "./node-map-list";

L.Icon.Default.imagePath =
  "//cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/";

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      flexGrow: 1,
    },
    avatar: {
      borderRadius: "0%",
      width: 20,
      height: 20,
    },
  })
);

interface Props {
  nodes: any[];
  widgetStatic?: boolean;
  widgetTitle?: string;
}

// FIXME https://yuzhva.github.io/react-leaflet-markercluster/#marker-options

// TODO map height 100% (maybe based on client bounding rect)
const NodeMap2 = (props: Props) => {
  const classes = useStyles(props);
  // const { match } = props;
  const { nodes = [] } = props;
  const [zoom /*, setZoom*/] = useState(3);
  // const leaflet = useLeaflet();
  // TODO Set correct url (not demo.adcon.at)
  const nodesWithGeo =
    nodes &&
    nodes.filter((node) => {
      return (
        node.latitude &&
        node.latitude !== 0.0 &&
        node.longitude &&
        node.longitude !== 0.0
      );
    });

  const markers =
    nodesWithGeo &&
    nodesWithGeo.map((node) => {
      return (
        <Marker key={node.id} position={[node.latitude, node.longitude]}>
          <Popup autoPan={false}>
            <Card elevation={0}>
              <CardHeader
                avatar={
                  <Avatar
                    src={`http://demo.adcon.at/${node.imagePath}`}
                    className={classes.avatar}
                  />
                }
                title={node.name}
                subheader={node.formattedTimeStamp}
              />
              <CardContent>
                <NodeMapList node={node} />
              </CardContent>
            </Card>
          </Popup>
        </Marker>
      );
    });

  return (
    <MapContainer
      center={[48, 16]}
      zoom={zoom}
      maxZoom={18}
      style={{ height: "100%" /*, overflow: "visible"*/ }}
    >
      <TileLayer
        attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      <MarkerClusterGroup>{markers}</MarkerClusterGroup>
    </MapContainer>
  );
};

export default NodeMap2;
